import React from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

const CONFIRM_MESSAGE = 'Do you want to leave this page? Changes you made will not be saved.';

export function useLeavePageBlock(prompt?: boolean) {
    // It's a weird one, shouldn't be a problem, but if we migrate to data router we could just use useBlocker
    // And in general data routers seems to be better structured, so might consider one later
    const { navigator } = React.useContext(UNSAFE_NavigationContext);

    // Block in-app navigation (navigate(), <Link> clicks, navigate(-1), etc.)
    React.useEffect(() => {
        if (!prompt) {
            return;
        }

        const { push, replace, go } = navigator;

        navigator.push = (...args: Parameters<typeof push>) => {
            // eslint-disable-next-line no-alert
            if (window.confirm(CONFIRM_MESSAGE)) {
                push.apply(navigator, args);
            }
        };

        navigator.replace = (...args: Parameters<typeof replace>) => {
            // eslint-disable-next-line no-alert
            if (window.confirm(CONFIRM_MESSAGE)) {
                replace.apply(navigator, args);
            }
        };

        navigator.go = (...args: Parameters<typeof go>) => {
            // eslint-disable-next-line no-alert
            if (window.confirm(CONFIRM_MESSAGE)) {
                go.apply(navigator, args);
            }
        };

        return () => {
            navigator.push = push;
            navigator.replace = replace;
            navigator.go = go;
        };
    }, [navigator, prompt]);

    // Block browser tab close / refresh
    React.useEffect(() => {
        const preventNav = (event: BeforeUnloadEvent) => {
            if (!prompt) {
                return;
            }
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', preventNav);
        return () => {
            window.removeEventListener('beforeunload', preventNav);
        };
    }, [prompt]);
}
